import React from 'react'
import PropTypes from 'prop-types'

import CustomerDialog from '../common/CustomerDialog'
import CustomerUtils from '../Utils'

const FIELDS = [
  { display: 'Customer Name', key: 'name', type: 'text', required: true },
  { display: 'Customer Id', key: 'customerId', type: 'text' },
  { display: 'Primary Contact', key: 'primaryContact', type: 'subheader'},
  { display: 'Name', key: 'contactName', type: 'text', required: true },
  { display: 'Email', key: 'email', type: 'text' },
  { display: 'Address', key: 'address', type: 'address' },
  { display: 'Phone Number', key: 'phoneNumber', type: 'text' }
]

class AddCustomerDialog extends React.Component {

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    onSave: PropTypes.func.isRequired
  }

  onSave = (customer) => {
    const { teamId, onSave } = this.props
    const result = CustomerUtils.createNewCustomerObj(customer, teamId)
    CustomerUtils.saveCustomerObj(result.customerObj, teamId)
    onSave(result.id, result.contactId, result.customerObj)
  }

  render() {
    const props = Object.assign({}, this.props, {
      title: 'New Customer',
      fields: FIELDS,
      onSave: this.onSave
    })
    return <CustomerDialog {...props} />
  }

}

export default AddCustomerDialog



// WEBPACK FOOTER //
// ./src/customer/CustomerInterfaces/AddCustomerDialog.js